import { Screen } from '@modules/shared/services/window.service';

import { MediaSetting } from '../media-setting.interface';

export const SquareSectionImageStyleLarge: MediaSetting[] = [
  { screen: Screen.XXXS, key: '2_1_568', width: 568, height: 284, ratio: 2 },
  { screen: Screen.XS, key: '1_1_568', width: 768, height: 768, ratio: 1 },
  { screen: Screen.SM, key: '1_1_768', width: 1024, height: 1024, ratio: 1 },
  { screen: Screen.MD, key: '2_1_1366', width: 1366, height: 683, ratio: 2 },
  { screen: Screen.LG, key: '8_3_1600', width: 1600, height: 602, ratio: 2.66 },
  { screen: Screen.XL, key: '1_1_900', width: 1024, height: 1024, ratio: 1 },
];

export const SquareSectionImageStyleSmall: MediaSetting[] = [
  { screen: Screen.XXXS, key: '2_1_568', width: 568, height: 284, ratio: 2 },
  { screen: Screen.XS, key: '3_2_300', width: 300, height: 150, ratio: 1.5 },
];
